import React, { useEffect, useState } from "react"
import { ILimitStep, IQuery, IQueryBuilderContext, IStepValidationResponse, StepType } from "@types"
import { findSourceById, getSelectedStepDetailsById, handleStepFieldValueChanges,  registerStep, validateSource, validateStep, validateStepNameAndId } from "@utils"
import { FormSection } from "@components/FormSection/FormSection"
import { SourceSelectorInput } from "../SourceSelector/SourceSelectorInput"
import { updateSource, updateStep } from "../StepConfigUtils"
import { hasValue, Input } from "uxp/components"
import Icon from '@images/limit.svg'

export function renderStep(context: IQueryBuilderContext, query: IQuery, onChange: (query: IQuery) => void, selectedStepId: string) {
    const { step, index, previousSteps, selectedSources } = getSelectedStepDetailsById(query, selectedStepId)
    const _step: ILimitStep = Object.assign({}, step as ILimitStep)

    const [errors, setErrors] = useState<Record<string, string>>({})

    const [currentValue, setCurrentValue] = useState(_step?.rows?.toString() || '');

    useEffect(() => {
        const { isValid, errors } = validateStep(query, step as ILimitStep)
        setErrors(errors)
    }, [step])

    const source = findSourceById(query, _step?.source)

    async function onValueChange(field: string, value: any, source?: boolean) {
        const _query = await handleStepFieldValueChanges(context, query, selectedStepId, field, value, source)
        onChange(_query)
    }

    function submitValue() {
        var x = Number(currentValue) || 0;
        onValueChange('rows', x);
        setCurrentValue(x.toString());
    }

    return <React.Fragment>
        <FormSection
            label='Source 01'
            error={errors?.source1}
        >
            <SourceSelectorInput
                source={source}
                onChange={(newSource) => { onValueChange('source', newSource, true) }}
                availableSources={[...previousSteps, ...selectedSources]}
                query={query}
            />
        </FormSection>

        <FormSection
            label='Max number of records'
            error={errors?.rows}
        >
            <Input
                value={currentValue}
                onChange={(v) => {
                    setCurrentValue(v);
                }}
                onBlur={() => {
                    submitValue();

                }}
                onKeyDown={(e) => {
                    if (e.key == 'Enter') {
                        submitValue();
                    }
                }}
            />
        </FormSection>

    </React.Fragment>
}

function validate(query: IQuery, step: ILimitStep): IStepValidationResponse {
    const errors: Record<string, string> = validateStepNameAndId(step);
    // validate source
    const source = validateSource(query, step, 'source')
    if (!source.isValid) errors.source = source.error

    if (!hasValue(step?.rows)) errors.rows = 'Number of rows must be grater than zero'

    return { isValid: Object.keys(errors).length === 0, errors };
}

registerStep({
    type: StepType.Limit,
    name: "Limit",
    description: "Limit the number of records",
    icon: Icon,
    iconStyles: { backgroundSize: '55%' },
    render: renderStep,
    validate: validate,
    onSelectStep: (basicProps, previousSource) => {
        return { ...basicProps, source: previousSource, rows: 10, } as ILimitStep
    }
})